import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import { Color } from 'core';

interface CreateFlowBackButtonProps {
  onClick: () => void;
}

export const CreateFlowBackButton = ({ onClick }: CreateFlowBackButtonProps) => (
  <BackButton onClick={onClick}>
    <FontAwesomeIcon icon={faArrowLeft} />
    <span>Back</span>
  </BackButton>
);

const BackButton = styled.button`
  background: none;
  border: none;
  color: ${Color.darkGray};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  padding: 0;
  margin-bottom: 24px;
  z-index: 5;

  &:hover {
    color: ${Color.primaryBlue};
  }
`;